import React from "react"
import {observer} from "mobx-react-lite"
import ReactDatePicker, {registerLocale} from "react-datepicker"
import {syncOrdersController as controller} from "../../store/pageControllers/syncOrdersController"
import {Field, Fields, Select as WaSelect, WaCheckbox} from "../../lib/wa-2.0"
import CliApi from "../../api/CliApi"
import "./react-datepicker.min.css"
import {BrowserRouter, NavLink, Route} from "react-router-dom"
import {appPages} from "../../App"
import {appPath} from "../../index"
import ru from "date-fns/locale/ru"
import {TaskControls} from "../../components/task_buttons/TaskControls"
import {StateActionsTables} from "./StateActionsTables"


export const OrdersSyncPage = observer(() => {

    React.useEffect(() => {
        controller.loadSettings()
    }, [])
    registerLocale("ru", ru)

    return <>
        <h1>Синхронизация заказов</h1>

        <Fields className={"custom-mb-12"}>
            <Field label={"Дата начала синхронизации"}>
                <ReactDatePicker
                    className={"width-40"}

                    locale={"ru"}
                    selected={controller.since_date}
                    onChange={(date) => {
                        if (date instanceof Date) {
                            controller.since_date = date
                        }
                    }}
                    dateFormat="dd.MM.yyyy"/>
            </Field>
            <Field label={"Сопоставить товары по:"}>
                <WaSelect
                    className={"width-40"}
                    options={controller.productSyncByOptions}
                    value={controller.sync_by}
                    onChange={(e) => controller.sync_by = e.target.value}
                />
            </Field>
            <Field label={"Добавить номер заказа в комментарий"}>
                <WaCheckbox
                    fontSize={"16px"}
                    checked={controller.addPostingNumber2comment}
                    onChange={(e) => controller.addPostingNumber2comment = e.target.checked}
                />
            </Field>
            <Field label={"Добавить дату отгрузки в комментарий"}>
                <WaCheckbox
                    fontSize={"16px"}
                    checked={controller.addSendDate2comment}
                    onChange={(e) => controller.addSendDate2comment = e.target.checked}

                />
            </Field>
            <Field label={"Добавить ФИО клиента в комментарий"}>
                <WaCheckbox
                    fontSize={"16px"}
                    checked={controller.fioInComment}
                    onChange={(e) => controller.fioInComment = e.target.checked}

                />
            </Field>
            <Field label={"Способ доставки, который будет выбран в заказе:"}>
                <WaSelect
                    className={"width-40"}
                    options={controller.shippingMethods}
                    value={controller.defaultShippingMethod}
                    onChange={(e) => controller.defaultShippingMethod = e.target.value}
                />
            </Field>
            <Field label={"Способ оплаты, который будет выбран в заказе:"}>
                <WaSelect
                    className={"width-40"}
                    options={controller.paymentMethods}
                    value={controller.defaultPaymentMethod}
                    onChange={(e) => controller.defaultPaymentMethod = e.target.value}
                />
            </Field>
            <Field label={"Создавать экспресс-заказы на один контакт"}>
                <WaCheckbox
                    fontSize={"16px"}
                    checked={controller.singleExpressCustomer}
                    onChange={(e) => controller.singleExpressCustomer = e.target.checked}

                />
            </Field>
            <Field label={"ID контакта для заказов"}>
                <input
                    className={"long"}
                    onChange={e => controller.ozonCustomerId = e.target.value}
                    type="text"
                    value={controller.ozonCustomerId || ""}
                />
            </Field>
            <Field label={"Не разделять заказ с несколькими отправлениями"}>
                <WaCheckbox
                    fontSize={"16px"}
                    checked={controller.isMultiOrder}
                    onChange={(e) => controller.isMultiOrder = e.target.checked}

                />
            </Field>
            <Field label={"Подставлять дату доставки"}>
                <WaCheckbox
                    fontSize={"16px"}
                    checked={controller.pickShippingDate}
                    onChange={(e) => controller.pickShippingDate = e.target.checked}

                />
            </Field>

            <Field label={"Не создавать заказы с не найденными товарами"}>
                <WaCheckbox
                    fontSize={"16px"}
                    checked={controller.noOrderIfEmptyItem}
                    onChange={(e) => controller.noOrderIfEmptyItem = e.target.checked}

                />
            </Field>

        </Fields>
        <div className={"custom-my-32"}>
            <div className={"custom-mb-12"}>
                Для синхронизации заказов добавьте в CRON или запустите вручную
            </div>
            <TaskControls command={controller.syncOrdersCommand} start={CliApi.runSyncOrders}/>
        </div>
        {(controller.isStatesLoaded && controller.stateAndActionGroupedPairs) &&
            <div>
                <h4>Сопоставление действий магазина и статусов Ozon</h4>

                <BrowserRouter basename={appPath + appPages.ordersSync}>
                    <div className="toggle custom-mb-12">

                        {controller.stateAndActionGroupedPairs.map((ozonState, index) =>
                            <NavLink
                                activeClassName={"selected"}
                                isActive={((match, location) => {
                                    let model = ""
                                    if (location.pathname === "/") {
                                        model = "/FBS"
                                    } else {
                                        model = location.pathname
                                    }
                                    return model === "/" + ozonState.name
                                })}
                                to={"/" + ozonState.name} key={index}>
                                {ozonState.name}
                            </NavLink>
                        )}
                    </div>
                    <Route
                        path={"/:model"}
                        children={({match}) => <StateActionsTables model={match?.params.model}/>}
                    />
                </BrowserRouter>
            </div>}
        <Fields className={"custom-mt-32"}>
            <Field label={"Не отправлять обновления статусов в OZON, писать в логи:"}>
                <WaCheckbox
                    checked={controller.isDebugState}
                    onChange={(e) => controller.isDebugState = e.target.checked}
                />
            </Field>
        </Fields>


    </>

})
